import { Navbar } from "./Navbar";
import { useLang, translations } from "../i18n";

export function HeroSection() {
  const { lang } = useLang();
  const t = translations.hero;

  return (
    <section className="relative bg-[var(--background-dark)] text-white overflow-hidden">
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background: [
            "radial-gradient(ellipse 80% 50% at 50% 0%, rgba(247,147,26,0.12) 0%, transparent 50%)",
            "radial-gradient(ellipse 60% 40% at 30% 60%, rgba(247,147,26,0.04) 0%, transparent 50%)",
          ].join(", "),
        }}
      />
      <div
        className="absolute inset-0 pointer-events-none opacity-40"
        style={{
          backgroundImage: [
            "linear-gradient(rgba(255,255,255,0.02) 1px, transparent 1px)",
            "linear-gradient(90deg, rgba(255,255,255,0.02) 1px, transparent 1px)",
          ].join(", "),
          backgroundSize: "80px 80px",
        }}
      />

      <Navbar />

      <div className="relative z-10 max-w-6xl mx-auto px-6 md:px-12 pt-20 pb-28 md:pt-28 md:pb-36 flex flex-col items-center text-center">
        <div className="hero-animate hero-animate-delay-1 inline-flex items-center gap-2 text-xs font-semibold text-[var(--primary)] uppercase tracking-widest mb-8 px-3 py-1.5 bg-[var(--primary)]/10 border border-[var(--primary)]/20 rounded-full">
          <span className="w-1.5 h-1.5 rounded-full bg-[var(--primary)] animate-pulse" />
          <span>{t.eyebrow[lang]}</span>
        </div>

        <h1 className="hero-animate hero-animate-delay-2 text-4xl sm:text-5xl md:text-6xl lg:text-[72px] font-black tracking-[-0.04em] leading-[1.05] mb-5 max-w-4xl">
          {t.headline1[lang]}<span className="text-[var(--primary)]">.</span>
          <br />
          {t.headline2[lang]}<span className="text-[var(--primary)]">.</span>
        </h1>

        <p className="hero-animate hero-animate-delay-3 text-base md:text-lg text-white/50 mb-10 max-w-xl leading-relaxed">
          {t.subtitle[lang]}
        </p>

        <div className="hero-animate hero-animate-delay-4 flex flex-col sm:flex-row gap-3 mb-16">
          <a
            href="#waitlist"
            className="px-7 py-3.5 bg-[var(--primary)] hover:bg-[var(--accent-hover)] text-white text-sm font-bold tracking-wide rounded-lg transition-colors duration-150"
          >
            {t.cta1[lang]}
          </a>
          <a
            href="#how-it-works"
            className="px-7 py-3.5 bg-white/[0.06] hover:bg-white/[0.1] text-white text-sm font-semibold rounded-lg border border-white/10 hover:border-white/20 transition-all duration-150"
          >
            {t.cta2[lang]}
          </a>
        </div>

        <div className="hero-animate hero-animate-delay-5">
          <div className="flex items-center gap-0 text-[13px] font-mono">
            <div className="px-5 py-2.5 bg-white/[0.06] border border-white/[0.08] rounded-l-lg text-white/70">
              PIX <span className="text-white/30">(BRL)</span>
            </div>
            <div className="px-3 text-[var(--primary)] font-semibold">→</div>
            <div className="px-5 py-2.5 bg-[var(--primary)]/10 border border-[var(--primary)]/20 rounded-r-lg text-[var(--primary)] font-semibold">
              Lightning <span className="text-[var(--primary)]/60">(sats)</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
